import gql from 'graphql-tag';

export const ArrangementChecksQuery = gql`
    query checksQuery($formID: ID, $formType: String) {
        readFormArrangementChecks(ArrangementForm: $formID, FormType: $formType) {
            ID
            Checked
            ArrangementCheck {
                ID
                Title
                Page
                Section
                FormType
            }
        }
    }
`;

export const BuildArrangementChecksMutation = function(modified, formObject) {
    const args = modified
        .map((x, i) => {
            return `$input${i}: UpdateFormArrangementCheckInput!`;
        })
        .join(',');
    const mutations = modified
        .map((x, i) => {
            return `check${i}:updateFormArrangementCheck(input: $input${i}) {
        ID
        Checked
    }`;
        })
        .join('\n');

    let mutation = gql`
        mutation updateFormArrangementCheck(${args},$inputProgress:Update${formObject}Input!){
            ${mutations}
            progress: update${formObject}(input: $inputProgress){
                ID
                Progress
            }
        }
    `;
    return mutation;
};
